import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core'
import { OrgBrowserOrgList } from '../../models/org-browser-org-list'
import { OrgBrowserView } from '../../models/org-browser-view'

@Component({
    selector: 'pworg-list',
    templateUrl: './pworg-list.component.html',
    styleUrls: ['./pworg-list.component.scss']
})
export class PWOrgListComponent implements OnInit {
    _orgList: OrgBrowserOrgList
    loading: boolean
    get orgList() {
        return this._orgList
    }
    @Input('orgList')
    set orgList(value: OrgBrowserOrgList) {
        this._orgList = value
        this.updateOrganizations()
    }
    @Output() orgExpanded: EventEmitter<OrgBrowserView> = new EventEmitter()
    @Output() orgCollapsed: EventEmitter<OrgBrowserView> = new EventEmitter()
    @Output() orgAdded: EventEmitter<OrgBrowserView> = new EventEmitter()

    organizations: OrgBrowserView[] = [] as OrgBrowserView[]
    searchKeyword: string | undefined
    constructor() {}
    ngOnInit() {
        this.loading = false
        this.searchKeyword = undefined
    }

    onOrgExpandOrCollapse(org: OrgBrowserView): void {
        this.loading = true
        if (!org.expanded) {
            this.orgList.organizations.forEach((o) => {
                if (o.expanded) {
                    o.expanded = false
                    this.orgList.selectedOrganization = undefined
                    this.orgCollapsed.emit(o)
                }
            })
            org.expanded = true
            this.orgList.selectedOrganization = org
            this.orgExpanded.emit(org)
        } else {
            org.expanded = false
            this.orgList.selectedOrganization = undefined
            this.orgCollapsed.emit(org)
        }
        this.loading = false
    }

    updateOrganizations() {
        if (
            this._orgList !== undefined &&
            this._orgList !== null &&
            this._orgList.organizations !== undefined &&
            this._orgList.organizations !== null
        ) {
            if (this.searchKeyword === undefined || this.searchKeyword === '') {
                this.organizations = this._orgList.organizations
            } else {
                this.organizations = this._orgList.organizations.filter((o) =>
                    o.orgName.toLowerCase().includes(this.searchKeyword?.toLowerCase() || '')
                )
            }
        } else {
            this.organizations = [] as OrgBrowserView[]
        }
        const activeOrgs: OrgBrowserView[] = this.organizations.filter((o) => o.isActive === true)
        const inActiveOrgs: OrgBrowserView[] = this.organizations.filter((o) => o.isActive === false)

        this.organizations = activeOrgs.sort((a: OrgBrowserView, b: OrgBrowserView) => {
            if (a.orgName.toLowerCase() > b.orgName.toLowerCase()) {
                return 1
            } else if (a.orgName.toLowerCase() < b.orgName.toLowerCase()) {
                return -1
            } else {
                return 0
            }
        })
        this.organizations = this.organizations.concat(
            inActiveOrgs.sort((a: OrgBrowserView, b: OrgBrowserView) => {
                if (a.orgName.toLowerCase() > b.orgName.toLowerCase()) {
                    return 1
                } else if (a.orgName.toLowerCase() < b.orgName.toLowerCase()) {
                    return -1
                } else {
                    return 0
                }
            })
        )
    }

    searchChanged(keyword: string): void {
        this.searchKeyword = keyword
        this.updateOrganizations()
    }

    addOrg(org: OrgBrowserView) {
        org.selected = true
        this.orgAdded.emit(org)
    }

    orgInActive(org: OrgBrowserView): boolean {
        var today = new Date()
        today.setHours(0, 0, 0, 0)
        //if (org.orgName === 'Test@#$%^') {
        //    console.log(today);
        //    console.log(org.orgEffectiveDate);
        //    console.log(org.orgTerminationDate);
        //}

        if (
            org.orgEffectiveDate <= today &&
            (org.orgTerminationDate === undefined || org.orgTerminationDate === null || org.orgTerminationDate >= today)
        ) {
            return true
        }
        return false
    }
}
